<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Detail View Modal -->
      <div class="row">
        <b-modal
            id="modal-top-Details"
            hide-footer
            title="Details"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
              <h5>Detail</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <b-row>
              <b-col md="12">
               <b-table-simple
                 :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                    <b-tr>
                      <b-th colspan="7" style="font-weight: 700;text-align: center !important;">House Information</b-th>
                    </b-tr>
                      <b-tr style="font-weight: 700;text-align: center !important;">
                      <b-th style="width: 20%">Building Name</b-th>
                      <b-th style="width: 10%">Floor</b-th>
                      <b-th style="width: 10%">Room Number</b-th>
                      <b-th style="width: 15%">Size</b-th>
                      <b-th style="width: 15%">Price Option</b-th>
                      <b-th style="width: 15%">Description</b-th>
                      <b-th style="width: 10%">Status</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr>
                      <b-td>{{selectedHouse.HouseInformation.BuildingName}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.floor}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.roomNumber}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.size}} S.q.m</b-td>
                      <b-td>{{getOptionPrice(selectedHouse.HouseInformation.priceOption)}}</b-td>
                      <b-td>{{selectedHouse.HouseInformation.description}}</b-td>
                      <b-td>{{getStatus(selectedHouse.HouseInformation.status)}}</b-td>
                    </b-tr>
                  </b-tbody>
               </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" v-if="selectedHouse.ContractInformation && selectedHouse.ContractInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="6" style="font-weight: 700;text-align: center !important;">Contracts</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th></b-th>
                        <b-th>Tenant</b-th>
                        <b-th>Tenant Phone No</b-th>
                        <b-th>From</b-th>
                        <b-th>To</b-th>
                        <b-th>Total Payment Received</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(contract, index) in selectedHouse.ContractInformation"
                        :key="index"
                      >
                        <b-td>
                          <b-badge v-if="contract.Status == 1" variant="primary">Current</b-badge>
                        </b-td>
                        <b-td>{{contract.TenantFullName}}</b-td>
                        <b-td>{{contract.TenantPhoneNumber}}</b-td>
                        <b-td>{{contract.ContractStartDate}}</b-td>
                        <b-td>{{contract.ContractEndDate}}</b-td>
                        <b-td>{{numberWithCommas(contract.TotalAmountForThisContract)}}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="5" style="font-weight: 700;text-align: right !important;">Total</b-td>
                        <b-td style="font-weight: 700;">{{numberWithCommas(selectedHouse.TotalAmountForHouse)}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
              <b-col md="6">
               <b-table-simple
                  :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                     <b-tr>
                        <b-th colspan="5" style="font-weight: 700;text-align: center !important;">Price Information</b-th>
                     </b-tr>
                    <b-tr>
                      <b-th style="width: 5%"></b-th>
                      <b-th style="width: 15%">Price Options</b-th>
                      <b-th style="width: 12%">Price</b-th>
                      <b-th style="width: 12%">Created At</b-th>
                      <b-th style="width: 15%">Changed By</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(item, index) in selectedHouse.PriceInformation"
                      :key="index"
                    >
                      <b-td>
                         <b-badge v-if="item.Status == 1" variant="primary">Current</b-badge>
                      </b-td>
                      <b-td>{{item.priceOption}}</b-td>
                      <b-td>{{numberWithCommas(item.Price)}}</b-td>
                      <b-td>{{item.CreatedDate}}</b-td>
                      <b-td>{{item.registeredBy}}</b-td>
                    </b-tr>
                  </b-tbody>
               </b-table-simple>
              </b-col>
            </b-row>
             <b-row>
              <b-col md="8" v-if="selectedHouse.houseProperty && selectedHouse.houseProperty.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="4" style="font-weight: 700;text-align: center !important;">House Property</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th style="width: 12%">Property Name</b-th>
                        <b-th style="width: 12%">Property Status</b-th>
                        <b-th style="width: 12%">Created At</b-th>
                        <b-th>Changed By</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(property, index) in selectedHouse.houseProperty"
                        :key="index"
                      >
                        <b-td>{{property.propertyName}}</b-td>
                        <b-td>{{property.status}}</b-td>
                        <b-td>{{property.createdDate}}</b-td>
                        <b-td>{{property.createdBy}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" v-if="selectedHouse.OtherPriceInformation && selectedHouse.OtherPriceInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="8" style="font-weight: 700;text-align: center !important;">Other Bills</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th style="width: 5%"></b-th>
                        <b-th style="width: 12%">Electric Bill</b-th>
                        <b-th style="width: 12%">Water Bill</b-th>
                        <b-th style="width: 17%">Parking Charges</b-th>
                        <b-th style="width: 15%">Internet Cost</b-th>
                        <b-th style="width: 12%">Other Bills</b-th>
                        <b-th style="width: 12%">Created At</b-th>
                        <b-th>Changed By</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(other, index) in selectedHouse.OtherPriceInformation"
                        :key="index"
                      >
                        <b-td>
                          <b-badge v-if="other.Status == 1" variant="primary">Current</b-badge>
                        </b-td>
                        <b-td>{{numberWithCommas(other.electricPrice)}}</b-td>
                        <b-td>{{numberWithCommas(other.waterPrice)}}</b-td>
                        <b-td>{{numberWithCommas(other.parkingPrice)}}</b-td>
                        <b-td>{{numberWithCommas(other.internetPrice)}}</b-td>
                        <b-td>{{numberWithCommas(other.otherPrice)}}</b-td>
                        <b-td>{{other.CreatedDate}}</b-td>
                        <b-td>{{other.registeredBy}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
        </b-modal>
      </div>
      
      <!-- Main List View -->
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row class="mb-2">
                <b-col lg="2">
                  <label class="small mb-1">Building</label>
                  <b-form-select v-model="filterBuildingId" :options="buildingOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Owner</label>
                  <b-form-select v-model="filterUserId" :options="ownerUserOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Created By</label>
                  <b-form-select v-model="filterRegisteredBy" :options="allUserOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Created Date</label>
                  <b-form-input v-model="filterCreatedDate" type="date" size="sm"></b-form-input>
                </b-col>
                <b-col lg="2" class="d-flex align-items-end">
                  <b-button size="sm" variant="outline-secondary" @click="resetFilters">Reset</b-button>
                </b-col>
                <b-col lg="2" class="d-flex align-items-end">
                  <b-button size="sm" variant="success" class="mr-1" @click="exportExcel"><b-icon icon="file-earmark-excel"></b-icon> Excel</b-button>
                  <b-button size="sm" variant="danger" @click="exportPDF"><b-icon icon="file-earmark-pdf"></b-icon> PDF</b-button>
                </b-col>
                <b-col lg="2" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" placeholder="Search"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive="sm"
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Building Name</b-th>
                  <b-th>Floor</b-th>
                  <b-th>Room Number</b-th>
                  <b-th>Size</b-th>
                  <b-th>Price Option</b-th>
                  <b-th>Latest Price</b-th>
                  <b-th>Monthly Price</b-th>
                  <b-th>Other Bills</b-th>
                  <b-th>Status</b-th>
                  <b-th>Created Date</b-th>
                  <b-th>Created By</b-th>
                  <b-th sticky-column style="height: 45px;">Action</b-th>
                </b-tr>
              </b-thead>
              <template v-if="spinner">
                <b-tbody class="text-center">
                  <b-tr >
                    <b-td colspan="13" class="text-center" style="display: table-cell">
                      <b-spinner
                        style="height: 3rem; width: 3rem;"
                        variant="warning"
                      ></b-spinner>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </template>
              <template v-else>
                <template v-if="filterTable.length === 0">
                  <b-tbody class="text-center">
                    <b-tr>
                      <b-td colspan="13" class="text-center">Nothing found</b-td>
                    </b-tr>
                  </b-tbody>
                </template>
                <template v-else>
                  <b-tbody class="text-center">
                    <b-tr
                      v-for="(item, index) in filterTable"
                      :key="item.houseId"
                      @click="ViewDetail(item.houseId)"
                      style="cursor: pointer;"
                    >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.building ? item.building.buildingName : 'N/A'}}</b-td>
                      <b-td>{{item.floor}}</b-td>
                      <b-td>{{item.roomNumber}}</b-td>
                      <b-td>{{item.size}} S.q.m</b-td>
                      <b-td>{{getOptionPrice(item.priceOption)}}</b-td>
                      <b-td>{{numberWithCommas(item.latestPrice)}}</b-td>
                      <b-td>
                        <template v-if="item.priceOption === 'PerSquareMeter'">
                          {{numberWithCommas(item.latestPrice * item.size)}}
                        </template>
                        <template v-else>
                          {{numberWithCommas(item.latestPrice)}}
                        </template>
                      </b-td>
                      <b-td>{{numberWithCommas(item.otherPrice)}}</b-td>
                      <b-td>
                        <b-badge :variant="item.status == 1 ? 'success' : 'secondary'">
                          {{getStatus(item.status)}}
                        </b-badge>
                      </b-td>
                      <b-td>{{formatDate(item.createdDate)}}</b-td>
                      <b-td>{{item.registeredBy}}</b-td>
                      <b-td sticky-column>
                        <b-button 
                          variant="info" 
                          size="sm"
                          @click.stop="ViewDetail(item.houseId)"
                        >
                          <b-icon icon="eye"></b-icon>
                        </b-button>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </template>
              </template>
            </b-table-simple>
            
            <b-row>
              <b-col md="3">
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols="8" label-cols-xs="8" label-size="md"
                  label="records per page"
                  label-for="input-horizontal"
                  label-align-xl="right"  
                >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="9">
                <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="displayRows" @page-click="changePage" align="right"></b-pagination>
              </b-col>
            </b-row>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import * as XLSX from 'xlsx'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        perPage: 7,
        items: [],
        allItems: [],
        priceOptions: [
          {value:"PerSquareMeter", text: "Per Square Meter"},
          {value:"PerMonth", text: "Monthly"}
        ],
        selectedHouse: {
          houseId: null,
          HouseInformation: {
            floor: 0,
            roomNumber: "",
            registerDate: "",
            status: 0,
            size: "",
            latestPrice: "",
            BuildingName: "",
            description: ""
          },
          ContractInformation: [],
          TotalAmountForHouse: 0.0,
          PriceInformation: [],
          priceChangedNumber: 0,
          OtherPriceInformation: [],
          houseProperty: []
        },
        filter: "",
        spinner: true,
        filterBuildingId: null,
        filterUserId: null,
        filterRegisteredBy: null,
        filterCreatedDate: "",
        ownerUserOptions: [{value: null, text: "All Owners"}],
        allUserOptions: [{value: null, text: "All Users"}],
        buildingOptions: [{value: null, text: "All Buildings"}]
      }
    },
    mounted() {
      this.getModules();
      this.getAllHouseList();
      this.getOwnerUsers();
      this.getAllSystemUsers();
      this.getBuildings();
      this.$on("AfterComplete", () => {
        this.getAllHouseList();
      });
    },
    watch: {
      filterBuildingId() { this.applyFilters(); },
      filterUserId() { this.applyFilters(); },
      filterRegisteredBy() { this.applyFilters(); },
      filterCreatedDate() { this.applyFilters(); },
      filter(val) {
        if (val && val.trim()) this.fetchAllForSearch();
        else this.allItems = [];
      }
    },
    computed: {
      searchSource() {
        return this.filter && this.allItems.length ? this.allItems : this.items;
      },
      filterTable() {
        if (!this.filter) return this.items;
        const s = this.filter.trim().toLowerCase();
        return this.searchSource.filter(item => [
          item.building ? item.building.buildingName : '',
          item.floor, item.roomNumber, item.size,
          item.priceOption, item.latestPrice, item.otherPrice,
          item.registeredBy, item.createdDate,
          item.status == 1 ? 'rented' : 'free'
        ].some(v => v !== null && v !== undefined && String(v).toLowerCase().includes(s)));
      },
      displayRows() {
        return this.filter ? this.filterTable.length : this.totalRows;
      }
    },
    methods: {
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
            var modulesList = response.data.modules;
            var BuildingModule = modulesList.filter(x=>x.name === "HouseSuper");
            if(BuildingModule !== null && BuildingModule.length > 0){
              this.modulePermission.view = BuildingModule[0].listData || 0;
              this.modulePermission.create = BuildingModule[0].createData || 0;
              this.modulePermission.update = BuildingModule[0].updateData || 0;
              this.modulePermission.delete = BuildingModule[0].deleteData || 0;
            }
          })
          .catch(error=>{
            console.log(error);
          })
      },
      
      getStatus(status){
        return status == 1 ? "Rented" : "Free";
      },
      
      numberWithCommas(x) {
        if(x !== null && x !== undefined && x !== ''){
          var num = parseFloat(x);
          if(!isNaN(num)){
            return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
          return x;
        }
        return '0.00';
      },
      
      formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
          // Handle different date formats
          let date;
          if (typeof dateString === 'string') {
            date = new Date(dateString);
          } else {
            date = dateString;
          }
          return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
        } catch (e) {
          return dateString;
        }
      },
      
      buildPayload(page) {
        const payload = { page: page || this.currentPage, line: this.perPage };
        if (this.filterBuildingId) payload.buildingId = this.filterBuildingId;
        if (this.filterUserId) payload.userId = this.filterUserId;
        if (this.filterRegisteredBy) payload.registeredBy = this.filterRegisteredBy;
        if (this.filterCreatedDate) payload.createdDate = this.filterCreatedDate;
        return payload;
      },

      fetchAllForSearch() {
        if (!this.totalRows) return;
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllHouseList', payload)
          .then(response => { this.allItems = response.data.Contents || []; })
          .catch(error => { console.log('Error fetching all for search:', error); });
      },
      getAllHouseList() {
        this.spinner = true;
        this.allItems = [];
        this.$store.dispatch('getAllHouseList', this.buildPayload())
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
            if (this.filter && this.filter.trim()) this.fetchAllForSearch();
          })
          .catch(error => { console.log('Error fetching houses:', error); })
          .finally(() => { this.spinner = false; });
      },

      changePage(event, page) {
        this.currentPage = page;
        this.spinner = true;
        this.$store.dispatch('getAllHouseList', this.buildPayload(page))
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
          })
          .catch(error => { console.log('Error fetching houses:', error); })
          .finally(() => { this.spinner = false; });
      },

      changePerPage() {
        this.currentPage = 1;
        this.spinner = true;
        this.$store.dispatch('getAllHouseList', this.buildPayload(1))
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
          })
          .catch(error => { console.log('Error fetching houses:', error); })
          .finally(() => { this.spinner = false; });
      },

      getOwnerUsers() {
        this.$store.dispatch('getAllOwnerUsers')
          .then(response => {
            Array.from(response.data).forEach(user => {
              this.ownerUserOptions.push({ value: user.id, text: user.fullName + ' (' + user.username + ')' });
            });
          })
          .catch(error => { console.log(error); });
      },

      getAllSystemUsers() {
        this.$store.dispatch('getAllUsers')
          .then(response => {
            Array.from(response.data).forEach(user => {
              this.allUserOptions.push({ value: user.id, text: (user.fullName || (user.firstName + ' ' + user.lastName)) });
            });
          })
          .catch(error => { console.log(error); });
      },

      getBuildings() {
        this.$store.dispatch('getAllBuildingsList', {})
          .then(response => {
            Array.from(response.data).forEach(b => {
              this.buildingOptions.push({ value: b.buildingId, text: b.buildingName });
            });
          })
          .catch(error => { console.log(error); });
      },

      applyFilters() {
        this.currentPage = 1;
        this.getAllHouseList();
      },

      resetFilters() {
        this.filterBuildingId = null;
        this.filterUserId = null;
        this.filterRegisteredBy = null;
        this.filterCreatedDate = "";
        this.filter = '';
        this.allItems = [];
        this.currentPage = 1;
        this.getAllHouseList();
      },
      
      ViewDetail(ID){
        this.$store.dispatch('GetHouseDetailById', {houseId: ID})
        .then(response=>{
          this.selectedHouse = response.data;
          this.$bvModal.show('modal-top-Details');
        })
        .catch(error=>{
          this.$notifications.notify({
            message: (error.response && error.response.data) || 'Error loading house details',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
          console.log(error);
        })
      },
      
      getOptionPrice(option){
        if(option != undefined && option != null){
          var optionList = this.priceOptions.filter(x=>x.value == option);
          if(optionList.length > 0)
            return optionList[0].text;
          else
            return option;
        }else{
          return "";
        }
      },
      
      refreshData() {
        this.getAllHouseList();
      },
      
      fetchAllAndExport(format) {
        if (!this.totalRows) {
          this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
          return;
        }
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllHouseList', payload)
          .then(response => {
            const all = response.data.Contents || [];
            if (!all.length) {
              this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
              return;
            }
            if (format === 'excel') this.doExportExcel(all);
            else this.doExportPDF(all);
          })
          .catch(error => { console.log('Export error:', error); });
      },

      exportExcel() { this.fetchAllAndExport('excel'); },
      exportPDF()   { this.fetchAllAndExport('pdf'); },

      doExportExcel(all) {
        const data = all.map((item, i) => ({
          'No.': i + 1,
          'Building Name': item.building ? item.building.buildingName : 'N/A',
          'Floor': item.floor,
          'Room Number': item.roomNumber,
          'Size': item.size + ' S.q.m',
          'Price Option': this.getOptionPrice(item.priceOption),
          'Latest Price': this.numberWithCommas(item.latestPrice),
          'Monthly Price': item.priceOption === 'PerSquareMeter' ? this.numberWithCommas(item.latestPrice * item.size) : this.numberWithCommas(item.latestPrice),
          'Other Bills': this.numberWithCommas(item.otherPrice),
          'Status': this.getStatus(item.status),
          'Created Date': item.createdDate,
          'Created By': item.registeredBy
        }));
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Houses');
        XLSX.writeFile(wb, 'Houses.xlsx');
      },

      doExportPDF(all) {
        const doc = new jsPDF({ orientation: 'landscape' });
        doc.text('Houses List', 14, 14);
        const rows = all.map((item, i) => [
          i + 1,
          item.building ? item.building.buildingName : 'N/A',
          item.floor,
          item.roomNumber,
          item.size + ' S.q.m',
          this.getOptionPrice(item.priceOption),
          this.numberWithCommas(item.latestPrice),
          item.priceOption === 'PerSquareMeter' ? this.numberWithCommas(item.latestPrice * item.size) : this.numberWithCommas(item.latestPrice),
          this.numberWithCommas(item.otherPrice),
          this.getStatus(item.status),
          item.createdDate,
          item.registeredBy
        ]);
        doc.autoTable({
          head: [['No.','Building Name','Floor','Room Number','Size','Price Option','Latest Price','Monthly Price','Other Bills','Status','Created Date','Created By']],
          body: rows,
          startY: 20
        });
        doc.save('Houses.pdf');
      },

      clearData(){
        this.selectedHouse = {
          houseId: null,
          HouseInformation: {
            floor: 0,
            roomNumber: "",
            registerDate: "",
            status: 0,
            size: "",
            latestPrice: "",
            BuildingName: "",
            description: ""
          },
          ContractInformation: [],
          TotalAmountForHouse: 0.0,
          PriceInformation: [],
          priceChangedNumber: 0,
          OtherPriceInformation: [],
          houseProperty: []
        };
        this.$emit('AfterComplete');
      }
    }
  }
</script>

<style scoped>
.b-table-sticky-column:last-child {
  right: 0;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon{
  font-size: 27px !important;
  padding: 3px 5px 3px 5px;
  width: 40px;
  color:  rgb(37, 91, 48);
  border: 2px solid rgb(37, 91, 48);
}
.btn-icon:hover,
.btn-icon:focus {
  cursor: pointer;
  background-color: rgb(37, 91, 48) !important;
  color: rgba(240, 206, 13, 0.937) !important;
  border-radius: 4px;
  transition: .4s;
}
.b-table-simple tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
  cursor: pointer;
}
.close-icon {
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
}
.close-icon:hover {
  color: #dc3545;
}
</style>